export default __webpack_public_path__ + "static/media/IMG_5115.95256d06.JPG";